import { Component, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { MatSidenav, MatSnackBar } from "@angular/material";
import { HttpClient } from "@angular/common/http";
import { MatDialog } from "@angular/material";
import { LayerService } from "../layer/layer.service";
import { PoiService } from "../poi/poi.service";
import { UserService } from "../users/user.service";
import { CitiesService } from "../cities/cities.service";
import { LocationsService } from "../user/locations.service";
import { LoggerService } from "../logger.service";
import Amplify from "aws-amplify";
import { AmplifyService } from "aws-amplify-angular";
import aws_exports from "../../aws-exports";

Amplify.configure(aws_exports);

import { GeolocationService } from "../user/geolocation.service";
import { TranslateService } from "../translate.service";
import { LocalStorageService } from "../localstorage.service";

export interface PoiLayer {
  id: string;
  name: string;
  color: string;
}
@Component({
  selector: "app-visualize",
  templateUrl: "./visualize.component.html",
  styleUrls: ["./visualize.component.css"],
})
export class VisualizeComponent implements OnInit {
  @ViewChild("poiFormPanel") poiFormPanel: MatSidenav;

  private defaultPoiLayer = null;
  private user;
  private cities = [];
  private currentCity = null;
  private pois = [];
  private poilayers = [];
  private poitypes = [];
  private poitypestructure = [];
  private selectedPoiLayers = [];
  private poiData = null;
  private poiDataUpdates = null;
  private poiFiles = [];
  private poiID = "";
  private poiForm = {};
  private poiFormPanelStatus = false;
  private currentPoiType = "";
  private lastInsertedPoi = null;
  private currentPoiLayer = null;
  private map;
  private bounds = null;
  private poiQrcode = null;
  private borderPolygon;
  private poiIconSize = 25;
  private layerLocked = true;
  private poitypeLocked = true;
  private poiAction = null;
  private poiInfowindowdata = null;
  private userGeolocationObj = null;
  private userPreferencies = [];
  private userPositions = [];
  private searchpoi_data = null;
  private showLegend = true;
  private currentMarker = {
    index: null,
    position: {
      latitude: 0,
      longitude: 0,
    },
    marker: null,
    layer: null,
  };
  private mapCenter = {
    latitude: 0,
    longitude: 0,
    zoom: 3,
  };
  private mapOptions = {
    disableBirdseye: true,
    disableStreetside: false,
    navigationBarMode: 1,
    zoom: 3,
    showCopyright: false,
  };

  private currentUserPosition = null;

  private currentUserPositionIcon =
    "data:image/svg+xml;utf-8," +
    encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <circle cx="16" cy="16" r="10" fill="#2196f3" opacity="0.25"/>
      <circle cx="16" cy="16" r="6" fill="#2196f3" stroke="white" stroke-width="3"/>
    </svg>
  `);

  private ownerColors = {
    "0": "rgb(58,83,155)", //Blue - Municipale
    "1": "rgb(235, 59, 91)", //Rosso bordeux - Enel Sole
    "2": "rgb(0,200,83)", //Rosso acceso - Enel Distribuzione
    "3": "rgb(254, 1, 0)", // Verde - Progetto
    "999": "rgb(254, 211, 46)", // Arancio - Altro
  };

  loadPoisOnMap() {
    let self = this;
    if (self.poilayers) {
      for (let layer of self.poilayers) {
        layer.poi = {};
        layer.poi.items = [];
        self.loadAllFromLayer(
          layer,
          self.user.organization,
          self.bounds.maxLatitude,
        );
      }
    }
  }

  updateMapBounds(e) {
    this.bounds = {};
    this.bounds.maxLatitude = e.getNorthEast().lat();
    this.bounds.maxLongitude = e.getNorthEast().lng();
    this.bounds.minLatitude = e.getSouthWest().lat();
    this.bounds.minLongitude = e.getSouthWest().lng();
  }

  clearPoisOnMap() {
    let self = this;
    if (self.poilayers) {
      for (let layer of self.poilayers) {
        layer.poi = {};
        layer.poi.items = [];
      }
    }
  }

  poiFormPanelEvent(e) {
    this.poiFormPanelStatus = e;
  }

  private mapReady(map) {
    let self = this;
    if (map) {
      map.controls[google.maps.ControlPosition.TOP_LEFT].push(
        document.getElementById("poi-map-toptoolbar-left"),
      );
      map.setOptions({
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_CENTER,
        },
        mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          position: google.maps.ControlPosition.BOTTOM_LEFT,
        },
        streetViewControl: true,
        streetViewControlOptions: {
          position: google.maps.ControlPosition.RIGHT_CENTER,
        },
        fullscreenControl: false,
      });
      self.map = map;
      self.map.setOptions({ tilt: 0 });
    }
  }

  private resetCurrentMarker() {
    let self = this;
    self.poiFormPanel.close();
    self.poiFiles = [];
    self.poiID = null;
    if (
      self.isNumeric(self.currentMarker.layer) &&
      self.isNumeric(self.currentMarker.index)
    ) {
      if (
        self.currentMarker &&
        self.isNumeric(self.currentMarker.layer) &&
        self.isNumeric(self.currentMarker.index) &&
        self.poilayers[self.currentMarker.layer] &&
        self.poilayers[self.currentMarker.layer].poi &&
        self.poilayers[self.currentMarker.layer].poi.items &&
        self.poilayers[self.currentMarker.layer].poi.items[
          self.currentMarker.index
        ] &&
        self.poilayers[self.currentMarker.layer].poi.items[
          self.currentMarker.index
        ].current
      )
        self.poilayers[self.currentMarker.layer].poi.items[
          self.currentMarker.index
        ].current = false;
      self.currentMarker.index = null;
      self.currentMarker.marker = null;
      self.currentMarker.position.latitude = 0;
      self.currentMarker.position.longitude = 0;
    }
  }

  private poiIcon(poi) {
    let self = this;
    let icon = "";
    let color = "red";

    const fallbackIcon = function (fillColor: string) {
      return (
        'data:image/svg+xml;utf-8,<svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" width="' +
        self.poiIconSize +
        '" height="' +
        self.poiIconSize +
        '" viewBox="0, 0, ' +
        self.poiIconSize +
        ", " +
        self.poiIconSize +
        '">' +
        '<circle fill="' +
        fillColor +
        '" cx="' +
        (self.poiIconSize / 2).toFixed(1) +
        '" cy="' +
        (self.poiIconSize / 2).toFixed(1) +
        '" r="' +
        (self.poiIconSize / 2 - 3).toFixed(1) +
        '" /></svg>'
      );
    };

    const findPoiTypeById = function (id) {
      if (!id) return null;
      for (let poitype of self.poitypes) {
        if (poitype && poitype.id && poitype.id.toString() == id.toString())
          return poitype;
      }
      return null;
    };

    const findPoiTypeByName = function (name) {
      if (!name) return null;
      for (let poitype of self.poitypes) {
        if (
          poitype &&
          poitype.name &&
          poitype.name.toString() == name.toString()
        )
          return poitype;
      }
      return null;
    };

    const poiType =
      findPoiTypeById(poi.poiTypeId || (poi.type && poi.type.id)) ||
      findPoiTypeByName(poi.type && poi.type.name);
    if (poiType && poiType.icon) icon = poiType.icon;

    let data = null;
    if (poi.data) {
      try {
        data = typeof poi.data === "string" ? JSON.parse(poi.data) : poi.data;
      } catch (e) {
        data = null;
      }
    }

    if (data) {
      const poiTypeName =
        poiType && poiType.name ? poiType.name.toString() : "";
      const hasPostOwner =
        data.post_owner !== undefined &&
        data.post_owner !== null &&
        data.post_owner !== "";
      const hasCabinetOwner =
        data.cabinet_owner !== undefined &&
        data.cabinet_owner !== null &&
        data.cabinet_owner !== "";

      if (hasPostOwner && poiTypeName !== "cabinet") {
        switch (data.post_owner.toString()) {
          case "0":
            color = this.ownerColors["0"];
            break; // Municipal or public  blue
          case "1":
            color = this.ownerColors["1"];
            break; // EnelSole soft red
          case "3":
            color = this.ownerColors["3"];
            break; // EnelDistribuzione - red
          case "2":
            color = this.ownerColors["2"];
            break; // Project - green
          case "999":
            color = this.ownerColors["999"];
            break; // Other - orange
          default:
            color = "red";
        }
        if (!icon) {
          const lightingType = findPoiTypeByName("lighting");
          if (lightingType && lightingType.icon) icon = lightingType.icon;
        }
      }

      if (hasCabinetOwner && (poiTypeName === "cabinet" || !hasPostOwner)) {
        switch (data.cabinet_owner.toString()) {
          case "0":
            color = "rgb(58,83,155)";
            break; // Municipal or public - blue
          case "1":
            color = "rgb(0,200,83)";
            break; // EnelSole - green
          case "2":
            color = "rgb(128,0,128)";
            break; // Project - purple
          case "999":
            color = "rgb(128,128,128)";
            break; // Other - gray
          default:
            color = "red";
        }
        if (!icon) {
          const cabinetType = findPoiTypeByName("cabinet");
          if (cabinetType && cabinetType.icon) icon = cabinetType.icon;
        }
      }
    }

    if (!icon || icon == "-") return fallbackIcon(color);

    const template = icon.toString().trim().replace(/\\"/g, '"');
    const normalized =
      (template.charAt(0) === '"' &&
        template.charAt(template.length - 1) === '"') ||
      (template.charAt(0) === "'" &&
        template.charAt(template.length - 1) === "'")
        ? template.slice(1, -1)
        : template;

    const processedIcon = normalized
      .replace(/##SIZE##/g, self.poiIconSize.toString())
      .replace(/##SIZE2##/g, (self.poiIconSize / 2).toFixed(1).toString())
      .replace(
        /##SIZERADIUS##/g,
        (self.poiIconSize / 2 - 3).toFixed(1).toString(),
      )
      .replace(/##COLOR##/g, color);

    if (!processedIcon || processedIcon.trim() == "")
      return fallbackIcon(color);
    return processedIcon;
  }

  private isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  private poiEdit(marker, poi, layer, index) {
    let self = this;
    self.poiAction = "editing";
    if (
      marker &&
      poi &&
      poi.id &&
      self.isNumeric(index) &&
      self.isNumeric(layer)
    ) {
      self.poiData = null;
      self.poiFiles = [];
      self.poiID = null;
      self.poilayers[layer].poi.items[index].current = true;
      self.currentMarker.index = index;
      self.currentMarker.layer = layer;
      self.currentMarker.marker = marker.Marker;
      self.poiService
        .get(poi.id)
        .then((data) => {
          // Fallback to prevent race condition
          // if Annulla was pressed before this resolved, currentMarker was reset
          if (
            self.currentMarker.index !== index ||
            self.currentMarker.layer !== layer
          ) {
            return;
          }
          try {
            if (data && data.data && data.data.getPoi) {
              var poiData = data.data.getPoi;
              self.poiQrcode =
                "https://app2.egaia.net/Relieve/" +
                self.currentCity.id +
                "/" +
                poiData.id;
              self.currentPoiLayer = poiData.layer ? poiData.layer.id : null;
              self.currentPoiType = poiData.type ? poiData.type.id : null;
              if (poiData.type && poiData.type.structure) {
                self.poiForm = JSON.parse(poiData.type.structure);
              } else {
                console.warn(
                  "POI has no type or type.structure is missing, poi:",
                  poi.id,
                );
                const fallbackType = self.poitypes.find(
                  (pt) => pt.id === self.currentPoiType,
                );
                if (fallbackType && fallbackType.structure) {
                  self.poiForm = JSON.parse(fallbackType.structure);
                } else {
                  self.poiForm = {};
                }
              }
              self.poiID = poi.id;
              self.currentMarker.position.latitude = marker.latitude;
              self.currentMarker.position.longitude = marker.longitude;
              poiData.data = JSON.parse(poiData.data);
              if (poiData.data) {
                self.poiFiles = poiData.files;
                self.poiFormPanel.open();
                setTimeout(() => {
                  self.poiData = poiData.data;
                }, 0);
              } else {
                throw "Data of poi not present";
              }
            } else {
              throw "Data of poi not present";
            }
          } catch (e) {
            console.error("[poiEdit error]", e);
            self.resetCurrentMarker();
            self.poiFiles = [];
          }
        })
        .catch((err) => {
          self.logger.error(err);
        });
    }
  }

  private loadAllFromLayer(
    layer: object,
    organization: string,
    nextToken?: string,
  ) {
    let self = this;
    if (layer && layer["id"]) {
      self.citiesService
        .getAllPoiFromCityNoData(layer["id"], organization, nextToken)
        .then((data) => {
          if (
            data &&
            data.data &&
            data.data.getPoiLayer &&
            data.data.getPoiLayer.poi &&
            data.data.getPoiLayer.poi.items
          ) {
            layer["poi"]["items"] = layer["poi"]["items"].concat(
              data.data.getPoiLayer.poi.items,
            );
          }
          if (
            data &&
            data.data &&
            data.data.getPoiLayer &&
            data.data.getPoiLayer.poi &&
            data.data.getPoiLayer.poi.nextToken
          ) {
            self.loadAllFromLayer(
              layer,
              organization,
              data.data.getPoiLayer.poi.nextToken,
            );
          }
        })
        .catch((err) => {
          self.logger.error(err);
        });
    }
  }

  private delay(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }

  private paginate(array, page_size, page_number) {
    return array.slice((page_number - 1) * page_size, page_number * page_size);
  }

  private loadAllFromFile(layer: object) {
    let self = this;
    self.httpService
      .get(
        "https://qstorage160746-prod.s3.eu-west-1.amazonaws.com/public/static/" +
          layer["id"] +
          ".json?t=" +
          Date.now(),
      )
      .toPromise()
      .then(async (data: any[]) => {
        for (let i = 0; i < data.length; i++) {
          layer["poi"]["items"].push(data[i]);
          await self.delay(1);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  private loadRemote(id, organization, data?: boolean) {
    let self = this;
    self.citiesService
      .getLayersFromCity(id, organization)
      .then((data) => {
        if (
          data &&
          data.data &&
          data.data.getCities &&
          data.data.getCities.layers &&
          data.data.getCities.layers.items &&
          data.data.getCities.layers.items.length > 0
        ) {
          self.poilayers = data.data.getCities.layers.items;
          for (let layer of data.data.getCities.layers.items) {
            layer.poi = {};
            layer.poi.items = [];
            //self.loadAllFromLayer(layer, organization);
          }
        }
      })
      .catch((err) => {
        self.logger.error(err);
      });
  }

  private poiUndo() {
    let self = this;
    self.poiFormPanel.close();
    self.poiFiles = [];
    self.poiID = null;
    self.resetCurrentMarker();
  }

  private loadCity() {
    let self = this,
      poiNextToken = null;
    try {
      if (self.currentCity && self.user) {
        self.mapCenter.latitude = self.currentCity.position_lat;
        self.mapCenter.longitude = self.currentCity.position_lng;
        self.mapCenter.zoom = 12;
        self.poilayers = [];

        self.loadRemote(self.currentCity.id, self.user.organization, true);

        var borders = self.currentCity.area
          .toString()
          .replace(/['"]+/g, "")
          .split(" ");
        var bordersCoords = [];

        borders.forEach((border) => {
          var borderCord = border.toString().split(",");
          var latitude = parseFloat(borderCord[1]);
          var longitude = parseFloat(borderCord[0]);
          if (borderCord && borderCord.length > 2 && latitude && longitude)
            bordersCoords.push({ lat: latitude, lng: longitude });
        });
        if (self.borderPolygon) self.borderPolygon.setMap(null);
        self.borderPolygon = new google.maps.Polygon({
          paths: bordersCoords,
          strokeColor: "#3a539b",
          strokeOpacity: 1,
          strokeWeight: 4,
          fillColor: "#FFF",
          fillOpacity: 0,
        });
        self.borderPolygon.setMap(self.map);
      }
      self.defaultPoiLayer = self.localStorageService.get(
        "egaia_defaultlayer_on_" + self.currentCity.id,
      );
    } catch (e) {
      console.log(e);
    }
  }

  changeCity(city) {
    let self = this;
    self.currentCity = city.value ? city.value : null;
    self.loadCity();
  }

  selectLayer(e) {
    let self = this;
    if (self.selectedPoiLayers) {
      for (let layer of self.selectedPoiLayers) {
        layer.poi = {};
        layer.poi.items = [];
        self.loadAllFromFile(layer);
      }
    }
  }

  constructor(
    private httpService: HttpClient,
    private localStorageService: LocalStorageService,
    private translateService: TranslateService,
    private poiService: PoiService,
    private layerService: LayerService,
    private userService: UserService,
    private citiesService: CitiesService,
    private amplifyService: AmplifyService,
    private logger: LoggerService,
    private locationsService: LocationsService,
    private geolocationService: GeolocationService,
    private snackbar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
  ) {
    let self = this;

    self.poiService.subscribe(function (data) {
      if (
        data &&
        data.value &&
        data.value.data &&
        data.value.data.onCreatePoi &&
        data.value.data.onCreatePoi.id
      ) {
        if (self.lastInsertedPoi != data.value.data.onCreatePoi.id) {
          self.poiService
            .get(data.value.data.onCreatePoi.id)
            .then((data) => {
              try {
                if (
                  data &&
                  data.data &&
                  data.data.getPoi &&
                  data.data.getPoi.city &&
                  data.data.getPoi.city.id &&
                  data.data.getPoi.organizationID &&
                  data.data.getPoi.layer &&
                  data.data.getPoi.layer.id
                ) {
                  if (
                    self.currentCity.id == data.data.getPoi.city.id &&
                    self.user.organization == data.data.getPoi.organizationID
                  ) {
                    self.poilayers.forEach((poilayer) => {
                      if (poilayer.id == data.data.getPoi.layer.id) {
                        poilayer.poi.items.push({
                          id: data.data.getPoi.id ? data.data.getPoi.id : null,
                          data: data.data.getPoi.data
                            ? JSON.parse(data.data.getPoi.data)
                            : null,
                          type: { name: data.data.getPoi.type.name },
                          position_flr: data.data.getPoi.position_flr
                            ? data.data.getPoi.position_flr
                            : 0,
                          position_lat: data.data.getPoi.position_lat
                            ? data.data.getPoi.position_lat
                            : 0,
                          position_lng: data.data.getPoi.position_lng
                            ? data.data.getPoi.position_lng
                            : 0,
                        });
                        if (
                          self.userPreferencies &&
                          self.userPreferencies["notifynewpoints"] &&
                          self.userPreferencies["notifynewpoints"] == "y"
                        )
                          self.snackbar.open(
                            data.data.getPoi.owner + " added new poi",
                            "ok",
                            { duration: 2000, panelClass: ["white-snackbar"] },
                          );
                      }
                    });
                  }
                }
              } catch (e) {
                console.log(e);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    });
  }

  ngOnInit() {
    let self = this;
    let city = self.route.snapshot.paramMap.get("city");
    let selectedCity = null;

    self.userService.currentuserAvailable.subscribe((data) => {
      if (data) {
        self.user = self.userService.currentUser;
        self.cities = self.user.activecities.sort((a, b) =>
          a.name
            .toString()
            .toLowerCase()
            .localeCompare(b.name.toString().toLowerCase()),
        );
        self.poitypes = [];
        const orgPoiTypes_v = self.user.organizationObject.poiTypes;
        if (
          orgPoiTypes_v &&
          Array.isArray(orgPoiTypes_v) &&
          orgPoiTypes_v.length > 0
        ) {
          orgPoiTypes_v.forEach((poiTypeId: string) => {
            self.poiService
              .getType(poiTypeId)
              .then((poiType) => {
                if (poiType && poiType.data && poiType.data.getPoiType)
                  self.poitypes.push(poiType.data.getPoiType);
              })
              .catch((err) => {
                console.log(err);
              });
          });
        }
        self.route.params.subscribe((params) => {
          self.cities.forEach((city) => {
            if (city.name == params.city || city.id == params.city) {
              self.currentCity = city;
              self.loadCity();
            }
          });
        });
      }
    });

    // Inizialize user's position with a marker
    this.initializeUserPosition();
  }

  private moveToCurrentPosition() {
    let self = this;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          self.mapCenter.latitude = position.coords.latitude;
          self.mapCenter.longitude = position.coords.longitude;
          self.mapCenter.zoom = 15;
        },
        function (error) {
          switch (error.code) {
            case error.PERMISSION_DENIED:
              console.log("User denied the request for Geolocation.");
              break;
            case error.POSITION_UNAVAILABLE:
              console.log("Location information is unavailable.");
              break;
            case error.TIMEOUT:
              console.log("The request to get user location timed out.");
              break;
            default:
              console.log("An unknown error occurred.");
              break;
          }
        },
      );
    }
  }

  private defaultPoiLayerSelected(e) {
    let self = this;
    if (e && e.value) {
      self.localStorageService.set(
        "egaia_defaultlayer_on_" + self.currentCity.id,
        e.value,
      );
    }
  }

  private getPoiTypeFromId(id: String) {
    for (let poitype of this.poitypes)
      if (poitype.id.toString() == id.toString()) return poitype;
    return null;
  }

  private initializeUserPosition() {
    let self = this;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          self.mapCenter.latitude = position.coords.latitude;
          self.mapCenter.longitude = position.coords.longitude;
          self.mapCenter.zoom = 15;
          self.currentUserPosition = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            zoom: 15,
          };
        },
        function (error) {
          console.log("Geolocation error", error.code);
        },
      );
    }
  }
}
